<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <div id="user-data" v-if="user_data" >
      <vx-card :title="$t('PROFIL')" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="activeUserImg" class="rounded w-full" />
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("Nom") }} {{' :'}}</td>
                <td>{{ user_data.username}}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("Rôle") }} {{' :'}}</td>
                <td>{{ roleObject[ user_data.role]}}</td>
              </tr>
             <!--  <tr>
                <td class="font-semibold">{{ $t("Prénoms") }} {{' :'}}</td>
                <td>{{ user_data.first_name}}</td>
              </tr> -->
<!--              <tr>-->
<!--                <td class="font-semibold">Sexe :</td>-->
<!--                <td>{{sexeObject[user_data.gender]}}</td>-->
<!--              </tr>-->

            </table>
          </div>
          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <!-- <tr>
                <td class="font-semibold">{{ $t("Rôle") }} {{' :'}}</td>
                <td>{{ roleObject[ user_data.role]}}</td>
              </tr> -->
             <!--  <tr>
                <td class="font-semibold">{{ $t("mail") }} {{' :'}}</td>
                <td>{{ user_data.email}}</td>
              </tr> -->
            </table>
          </div>
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="activePrompt3 = true">{{ $t("Modifier_mon_mot_de_passe") }}</vs-button>
          </div>
        </div>
      </vx-card>


      <!-- Permissions -->

    </div>
    <vs-prompt
      color="danger"
      :title="$t('MODIFICATION_DE_MOT_DE_PASSE')"
      @cancel=" password= '';confirm_password='' "
      @accept="acceptAlert3"
      cancel-text="Annuler"
      accept-text="Confirmer"
      @close="close"
      :is-valid="validateForm"
      :active.sync="activePrompt3">
      
      <div class="con-exemple-prompt">
        <b>{{ $t("Entez_les_infomations_pour_continuer") }}</b>.
        <div>
          <div class=" flex flex-wrap-wrap items-center data-list-btn-container">
              <div class="flex flex-wrap-wrap items-center data-list-btn-container relative w-full mb-4" >
              <vs-input
                ref="password"
                :type="showPassword ? 'text' : 'password'"
                data-vv-validate-on="blur"
                v-validate="'required|min:8|max:15'"
                name="password"
                label-placeholder="Password"
                :placeholder="$t('Mot_de_passe')"
                v-model="password"
                class="w-full mt-5" />
              </div>
              <div class="btn-add-new p-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
                <feather-icon @click="showPassword = !showPassword" :icon="showPassword ? 'EyeIcon' : 'EyeOffIcon'" svgClasses="h-4 w-4" />
              </div>        
          </div>

        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
        </div>
        <div>
          <vs-input
            :type="showPassword ? 'text' : 'password'"
            v-validate="'min:8|max:15|confirmed:password'"
            data-vv-validate-on="blur"
            data-vv-as="password"
            name="confirm_password"
            label-placeholder="Confirm Password"
            :placeholder="$t('Confirmation_mot_de_passe')"
            v-model="confirm_password"
            class="w-full mt-8" />
          <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
        </div>
        <vs-alert :active="inputValid" color="danger" icon="new_releases" >
          {{ $t("Confirmation_mot_de_passe") }}
        </vs-alert>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    password: {
      required: 'Le champ mot de passe est obligatoire',
      min: 'Au minimum 8 caractères.',
      max: 'Au maximum 15 caractères.'
    },
    confirm_password: {
      required: 'Le champ confirmation mot de passe est obligatoire',
      min: 'Au minimum 8 caractères.',
      max: 'Au maximum 15 caractères.',
      confirmed:'La confirmation doit être identique au mot de passe saisie '
    }
  }
}
Validator.localize('fr', dict)

export default {
  data () {
    return {
      showPassword: false,
      roleObject: {
        'admin': 'ADMINISTRATEUR',
        'adminMoozi':'ADMINISTRATEUR MOOZISTUDIO',       
        'adminClient':'ADMINISTRATEUR CLIENT',
        'managerClient':'MANAGER CLIENT',
        'manager':'MANAGER TRANSVIE',
        'agent': 'AGENT COMMERCIAL'
      },
      sexeObject: {
        male: 'Masculin',
        female: 'Féminin'
      },
      user_data: [],
      password: '',
      confirm_password: '',
      activePrompt3:false,
      user_not_found: false,
      country:''
    }
  },
  watch: {
    activePrompt3 (val) {
      if (val === true) {
        this.password = ''
        this.confirm_password = ''
      }
    }
  },
  computed:{
    activeUserImg () {
      return require('@/assets/images/portrait/small/avatar-s-27.jpg') // From Auth
    },
    inputValid () {
      if (this.password !== '' && this.confirm_password !== '') {
        return false
      } else { return true }
    },
    validateForm () {
      return !this.errors.any() && this.password !== '' && this.confirm_password !== ''
    }

  },
  methods: {

    acceptAlert3 () {
      this.$vs.loading()
      const password = this.password
      this.$http.patch('change-password/', { password })
        .then((reponse) => {
          // localStorage.clear();
          this.$vs.notify({
            time:4000,
            title: this.$t('MOT_DE_PASSE_CHANGÉ'),
            text: reponse.data.message,
            color: 'success',
            position:'top-center'
          })
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.notify({
            time:4000,
            title: this.$t('ERROR_PASSWORD'),
            text: error.response.data.password[0],
            color: 'danger',
            position:'top-center'
          })
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.user_data = JSON.parse(localStorage.getItem('userInfo'))

  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


}

</style>
